/* istanbul ignore file */

import { makeFragmentData } from '@packages/gql/generated/shopping';
import {
  ColorTilesValuesFragmentFragmentDoc,
  type ColorTilesValuesFragmentFragment,
} from '@packages/gql/generated/shopping/graphql';
import deepmerge from 'deepmerge';

export const colorTilesDimensionDataMock: ColorTilesValuesFragmentFragment = {
  values: [
    {
      rgb: '000',
      displayText: 'black',
      sku: '1',
      image: 'https://bilder.baur.de/i/empiriecom/e2024bb057b29bca39b5e9dc8445bd66.jpg',
      isSelected: false,
    },
    {
      rgb: 'eee',
      displayText: 'offwhite',
      sku: '2',
      image: 'https://bilder.baur.de/i/empiriecom/4f05f51d0f43fc418cdb047082992b56.jpg',
      isSelected: true,
    },
    {
      rgb: null,
      displayText: 'green',
      sku: null,
      image: null,
      isSelected: false,
    },
  ],
};

export const colorTilesDimensionDataMockManyColors: ColorTilesValuesFragmentFragment = deepmerge(
  colorTilesDimensionDataMock,
  {},
);
colorTilesDimensionDataMockManyColors.values.concat([
  {
    displayText: 'gelb',
    image: 'https://bilder.baur.de/i/empiriecom/ae313398fd8e175eda64be8716915b67',
    isSelected: false,
    rgb: 'FF0',
    sku: '8711923547',
  },
  {
    displayText: 'grün',
    image: 'https://bilder.baur.de/i/empiriecom/87f691dab51fc061fa8617480d0d8e29',
    isSelected: false,
    rgb: '32DC32',
    sku: '5655903487',
  },
  {
    displayText: 'koralle',
    image: 'https://bilder.baur.de/i/empiriecom/88804ab2361f1070025546f1bd3ca1bb',
    isSelected: true,
    rgb: 'FFA500',
    sku: '4797554157',
  },
  {
    displayText: 'lila',
    image: 'https://bilder.baur.de/i/empiriecom/ee318eb05c9d72daf42bd0dbc6c8e8a0',
    isSelected: false,
    rgb: '9370D8',
    sku: '9640575948',
  },
  {
    displayText: 'mint',
    image: 'https://bilder.baur.de/i/empiriecom/166ecacb763def28137ab107e37d98bb',
    isSelected: false,
    rgb: '32DC32',
    sku: '6032834687',
  },
  {
    displayText: 'navy',
    image: 'https://bilder.baur.de/i/empiriecom/b43dcf240c83702e41ca487555c819cc',
    isSelected: false,
    rgb: '000080',
    sku: '2679774455',
  },
  {
    displayText: 'schwarz',
    image: 'https://bilder.baur.de/i/empiriecom/26b6b3b0f1cddc57e4f2616c7548219e',
    isSelected: false,
    rgb: '000',
    sku: '7697774729',
  },
  {
    displayText: 'türkis',
    image: 'https://bilder.baur.de/i/empiriecom/15e858e016cb4e8b4a7204bf7e371281',
    isSelected: false,
    rgb: '000080',
    sku: '7115066159',
  },
  {
    displayText: 'weiß',
    image: 'https://bilder.baur.de/i/empiriecom/17525f410dda1568053c6ae5445df00f',
    isSelected: false,
    rgb: 'FFF',
    sku: '4893580382',
  },
]);

export const colorTilesDimensionDataMockIncomplete: ColorTilesValuesFragmentFragment = {
  values: [
    {
      displayText: null,
      image: null,
      isSelected: null,
      rgb: null,
      sku: '8711923547',
    },
  ],
};

export const colorTilesDimensionDataMockNotSelected: ColorTilesValuesFragmentFragment = {
  values: [
    {
      displayText: null,
      image: null,
      isSelected: false,
      rgb: null,
      sku: '8711923547',
    },
  ],
};

export function getColorTilesDimensionFragmentedData(data?: ColorTilesValuesFragmentFragment) {
  return makeFragmentData(data || colorTilesDimensionDataMock, ColorTilesValuesFragmentFragmentDoc);
}
